// src/components/organisms/PatientWorkspaceTabs/_rowParts.js
//
// Master-detail listelerinde `SelectableListRow`'un `title` / `subtitle`
// alanlarına verilen ek satır parçaları. SelectableListRow bu alanları
// <Typography> (p) içinde çizdiği için buradaki her şey inline (span)
// elemanlarla kurulur — div/Chip(div) kullanmak DOM iç içe geçme hatası verir.

import React from "react";
import { Box, Chip } from "@mui/material";
import { Person as PersonIcon } from "@mui/icons-material";
import { COLORS } from "../../../styles/uiConstants";

/** Satır içi küçük chip (span köklü). */
export function RowChip({ label, icon, sx = {} }) {
  return (
    <Chip
      component="span"
      size="small"
      label={label}
      icon={icon}
      sx={{
        height: 18,
        fontSize: "0.7rem",
        fontWeight: 700,
        "& .MuiChip-label": { px: 0.85 },
        ...sx,
      }}
    />
  );
}

/** Alt başlıkta blok olarak akan tek satır (span, display:block|flex). */
export function RowLine({ children, flex = false, sx = {} }) {
  return (
    <Box
      component="span"
      sx={{
        display: flex ? "flex" : "block",
        ...(flex ? { alignItems: "center", gap: 0.75, flexWrap: "wrap" } : {}),
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: flex ? "normal" : "nowrap",
        mt: 0.4,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

/** "Son düzenleyen" satırı: kişi ikonu + ad + rol chip'i + göreli zaman. */
export function RowEditorLine({ editor, rel }) {
  if (!editor) return null;
  return (
    <RowLine flex sx={{ gap: 0.5 }}>
      <PersonIcon sx={{ fontSize: 14, color: COLORS.slate400 }} />
      <Box
        component="span"
        sx={{
          fontSize: "0.78rem",
          color: COLORS.slate600,
          fontWeight: 600,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {editor.name}
      </Box>
      {editor.role && (
        <RowChip
          label={editor.role}
          sx={{ fontWeight: 600, bgcolor: COLORS.slate100, color: COLORS.slate600 }}
        />
      )}
      {rel && (
        <Box component="span" sx={{ fontSize: "0.75rem", color: COLORS.slate400, ml: "auto" }}>
          · {rel}
        </Box>
      )}
    </RowLine>
  );
}

/** Satır sağındaki tarih/saat metni. */
export function RowMetaText({ children }) {
  return (
    <Box
      component="span"
      sx={{ fontSize: "0.75rem", color: COLORS.slate500, fontWeight: 600, whiteSpace: "nowrap" }}
    >
      {children}
    </Box>
  );
}
